import { CoreAPIRequest,StakeAPIRequest } from "./web-api-handler";

import { convertObjectToFormData, getAPIConfig, getUserId, getUserSfid, LocalStorage } from "./helpers";
import { appUtilityKeys } from "./constants";

export const APIhandler = {
  login: {
    requestLogin2FACode: (payload) => StakeAPIRequest.post("/mobile/loginRequestSms", payload),
    loginWith2FACode: (payload) => StakeAPIRequest.post("/mobile/loginSms", payload),
    sendVerificationCode: (uniqueContactID) =>
      CoreAPIRequest.post(`/api/resident/send_verification_code/${uniqueContactID}`),
  },

  alternativeLogin: {
    getAlternativeLoginFlag: () => CoreAPIRequest.get(`/api/helpers/alternative_login_flag/`),

    // TODO: Update this endpoint to be "multipart/form" instead of "application/json"
    // payload must be on the form of:
    // { form: { "address": "Address", "full_name": "full name", "birth_date": "01/01/20XX", "rent_amount": 1000.0, "move_in_date": "01/01/20xx" }  }
    alternativeIdentifyVerify: (payload) => CoreAPIRequest.post(`/api/residents/alternative_identify_verify/`, payload),

    // This endpoint must be a Content-type: multipart/form, so the payload would be:
    // payload example: { "form": { "email":"email@email.com", "phoneNumber": "+15551234567", "userId": "1231231231" } }
    loginViaAlternativeLogin: (payload) => StakeAPIRequest.post(`/mobile/alternativeLogin`, payload),
  },

  tokens: {
    getTransferToken: () => CoreAPIRequest.get("/mobile/get_transfer_token/", getAPIConfig(["userId"])),
    createLinkToken: () => CoreAPIRequest.post("/mobile/v2/create_link_token/", {}, getAPIConfig(["user"])),
    setAccessToken: (payload) => CoreAPIRequest.post("/mobile/set_access_token/", payload),
  },

  logout: {
    logout: () => StakeAPIRequest.post("/mobile/logout", {}, getAPIConfig(["xAccessToken"])),
  },

  platformSummary: {
    getMobileAppSummary: () => CoreAPIRequest.get("/api/helpers/itunes_data/"),
    getPlatformSummaryStats: () => CoreAPIRequest.get("/helpers/platform_summary_stats/"),
  },

  onboarding: {
    markOnboardingSeen: () => CoreAPIRequest.post("mobile/mark_onboarding_seen/", {}),
    contactInfoFromChatOnboarding: (payload) =>
      CoreAPIRequest.post("/helpers/contact_info_from_chat_onboarding/", payload),

    // TODO: Verify "auth" token on header
    // Each options is a string, but as financial goals and spendings have multiple options,
    // each selection is seperated with a ";"
    // Payload example: { "financial_goals": "save;invest;economic freedom", "spending_preferences": "spend all;payments;vacations" }
    saveSpendingFinancialGoals: (userId, payload) =>
      CoreAPIRequest.post(`/resident/${userId}/spending_preferences_and_financial_goals/`, payload),
  },

  deals: {
    requestDeals: () => CoreAPIRequest.post(`/mobile/deals/`, null, getAPIConfig(["userId", "userEmail"])),
    consumerDeals: () => CoreAPIRequest.get(`/api/v3/consumer_deals/`, getAPIConfig(["transferToken"])),
  },

  unclaimedTransactions: {
    getUnclaimedTransactions: () =>
      CoreAPIRequest.get("/mobile/unclaimed_transactions", getAPIConfig(["transferToken"])),
    claimUnclaimedTransactions: () =>
      CoreAPIRequest.post("/mobile/unclaimed_transactions/claim", {}, getAPIConfig(["transferToken"])),
  },

  bankConnections: {
    saveDefaultConnectedAcccount: (payload) =>
      CoreAPIRequest.post("/mobile/v2/save_account_selection_for_user/", payload, getAPIConfig(["transferToken"])),
    getConnectedAcccounts: () =>
      CoreAPIRequest.post(
        "/mobile/get_accounts_for_user/",
        { userId: getUserId() },
        getAPIConfig(["transferToken", "userId"]),
      ),
    getConnectedAcccountSelection: () =>
      CoreAPIRequest.post("/mobile/get_account_selection_for_user/", {}, getAPIConfig("userId")),

    // TODO: Verify if we need this endpoint. Dont remember when we use this. Also, confirm that the auth token is getting assigned.
    resetConnectedAcccount: () =>
      CoreAPIRequest.post(
        `mobile/${getUserId()}/connected_accounts/reset`,
        {},
        getAPIConfig(["transferToken", "userId"]),
      ),
  },

  stakeDebit: {
    getStakeDebit: () => CoreAPIRequest.get("/mobile/stake_debit/", getAPIConfig(["transferToken"])),
    applyStakeChecking: (payload) =>
      CoreAPIRequest.post("/api/stake_checking/apply/", payload, getAPIConfig(["transferToken"])),
    requestStakeDebitCard: () =>
      CoreAPIRequest.post("/mobile/stake_debit/request_card/", {}, getAPIConfig(["transferToken"])),
    getStakeDebitStatements: () =>
      CoreAPIRequest.get("/mobile/stake_debit/statements/list/", getAPIConfig(["transferToken"])),

    // TODO: Verify auth token on this one
    replaceCard: (depositAccountId) => CoreAPIRequest.post(`resident/${depositAccountId}/replace_card/`, {}),

    getStateDebitStatement: (payload) =>
      CoreAPIRequest.get(`api/view_statement`, {
        ...getAPIConfig(["transferToken"]),
        params: payload,
        responseType: "blob", // To handle PDF streaming
      }),

    requestVirtualStakeDebit: () =>
      CoreAPIRequest.post("/mobile/stake_debit/request_virtual_card/", {}, getAPIConfig(["transferToken"])),
    getCustomerTokenVerificationSMS: () =>
      CoreAPIRequest.get("/mobile/stake_debit/customer_token_verification_sms/", getAPIConfig(["transferToken"])),
    getCustomerTokenVerificationResponse: (payload) =>
      CoreAPIRequest.post(
        "/mobile/stake_debit/customer_token_verification_response/",
        payload,
        getAPIConfig(["transferToken"]),
      ),
    resetInsufficientBalanceForMembershipFeesAlert: () =>
      CoreAPIRequest.patch(
        "api/v2/resident/update/",
        { show_insufficient_membership_fees__c: false },
        getAPIConfig(["transferToken"]),
      ),
    resetStakeCheckingClosedForNonComplianceAlert: () =>
      CoreAPIRequest.patch(
        "api/v2/resident/update/",
        { show_account_closed_due_to_noncompliance__c: false },
        getAPIConfig(["transferToken"]),
      ),
    verifyPersonSynctera: (payload) =>
      CoreAPIRequest.post("/api/verify_person_synctera", payload, getAPIConfig(["transferToken"])),
    bankingLimits: () => CoreAPIRequest.get("/mobile/banking_limits", getAPIConfig(["transferToken"])),
  },

  payroll: {
    // TODO: On all payroll endpoints, confirm if auth token in here is the link token or the transfer link token
    // Also confirm that all endpoints get assigned with the auth token on the header

    getPayrollLinkToken: () =>
      CoreAPIRequest.get("/mobile/stake_payroll/get_link_token/", getAPIConfig(["transferToken"])),
    getPayrollAccounts: () => CoreAPIRequest.get("/mobile/stake_payroll/", getAPIConfig(["transferToken"])),

    // TODO: Find out why we use this endpoint. No clue!!! :(
    getUpdatePayrollAccountToken: (accountId) =>
      CoreAPIRequest.get(`/mobile/stake_payroll/account/${accountId}/`, getAPIConfig(["transferToken"])),

    disconnectPayrollAccount: (accountId) =>
      CoreAPIRequest.patch(
        `/mobile/stake_payroll/account/${accountId}/disconnect/`,
        {},
        getAPIConfig(["transferToken"]),
      ),
  },

  creditBuilder: {
    // TODO: Verify if the auth token is getting assigned on the header for all the credit reporting endpoints
    optInCreditReporting: (payload) =>
      CoreAPIRequest.post(
        `/v2/mobile/residents/${getUserId()}/credit_reporting/opt_in/`,
        payload,
        getAPIConfig(["transferToken"]),
      ),
    optOutCreditReporting: () =>
      CoreAPIRequest.post(
        `mobile/residents/${getUserId()}/credit_reporting/opt_out/`,
        {},
        getAPIConfig(["transferToken"]),
      ),
    getCreditReportDetails: () =>
      CoreAPIRequest.get("/api/resident/get_credit_report_details/", getAPIConfig(["transferToken"])),
  },

  resident: {
    getUserAccount: () => StakeAPIRequest.get(`mobile/account`, getAPIConfig(["xAccessToken"])),
    updateResident: (payload) =>
      CoreAPIRequest.patch("api/v2/resident/update/", payload, getAPIConfig(["transferToken"])),
    updateEmailAddress: (payload) =>
      CoreAPIRequest.patch("api/v2/resident/update/", payload, getAPIConfig(["transferToken"])),
    updatePhoneNumber: (payload) =>
      CoreAPIRequest.patch("api/v2/resident/update/", payload, getAPIConfig(["transferToken"])),
    updateDateOfBirthOrSNN: (payload) =>
      CoreAPIRequest.patch("api/v2/resident/update/", payload, getAPIConfig(["transferToken"])),

    emailChangeRequestVerification: (payload) =>
      StakeAPIRequest.post(`/mobile/emailChangeRequestVerification`, payload, getAPIConfig(["xAccessToken"])),
    emailChangeVerification: (payload) =>
      StakeAPIRequest.post(`/mobile/emailChangeVerification`, payload, getAPIConfig(["xAccessToken"])),

    phoneNumberChangeRequestVerification: (payload) =>
      StakeAPIRequest.post(`/mobile/phoneNumberChangeRequestSms`, payload, getAPIConfig(["xAccessToken"])),
    phoneNumberChangeVerification: (payload) =>
      StakeAPIRequest.post(`/mobile/phoneNumberChangeSms`, payload, getAPIConfig(["xAccessToken"])),
    getRentDetails: () => CoreAPIRequest.get("/api/resident/get_rent_details/", getAPIConfig(["transferToken"])),
  },

  transfers: {
    initiateVenmoTransfer: (amount) =>
      CoreAPIRequest.post("/mobile/v2/initiate_venmo_transfer/", { amount }, getAPIConfig("transferToken")),

    initiatePlaidWithdrawal: (payload) =>
      CoreAPIRequest.post("/mobile/v2/initiate_transfer/", payload, getAPIConfig("transferToken")),

    // TODO: make sure that "auth" token is getting assigned correctly on the header
    initiateACHDebit: ({ accountId, ...payload }) =>
      CoreAPIRequest.post(
        `mobile/connected_accounts/${accountId}/initiate_ach_debit/`,
        payload,
        getAPIConfig(["transferToken"]),
      ),
  },

  ledger: {
    getActivities: () => StakeAPIRequest.get(`mobile/activities/`, getAPIConfig(["xAccessToken"])),
  },

  astra: {
    // New endpoints
    createUserIntent: (payload) => CoreAPIRequest.post("/create_user_intent", payload, getAPIConfig(["formData"])),

    createTrustedAuthenticationToken: (payload) =>
      CoreAPIRequest.post("/create_trusted_authentication_token", payload, getAPIConfig(["formData"])),

    getAstraTokenUsingSessionToken: (payload) =>
      CoreAPIRequest.post("/authorize_astra_user_using_session_token", payload, getAPIConfig(["formData"])),

    getNewAstraTokens: (payload) => CoreAPIRequest.post("/get_astra_token", payload, getAPIConfig(["formData"])),

    fetchAstraCards: () => CoreAPIRequest.get("/fetch_astra_cards", getAPIConfig(["astraToken"])),

    fetchAstraAccounts: () => CoreAPIRequest.get("/fetch_astra_accounts", getAPIConfig(["astraToken"])),

    createTransferRoutine: (payload) =>
      CoreAPIRequest.post("/create_transfer_routine", payload, getAPIConfig(["astraToken", "formData"])),

    enableCardToCardPayment: (cardId, payload) =>
      CoreAPIRequest.patch(`/cards/${cardId}/enableCardToCardPayment`, payload, getAPIConfig()),

    deleteAstraCard: (cardId) => CoreAPIRequest.delete(`/delete_astra_card/${cardId}`, getAPIConfig(["astraToken"])),

    createAccountToCardTransferRoutineWithoutAuthToken: (payload) =>
      CoreAPIRequest.post("/create_account_to_card_transfer_routine", payload, getAPIConfig(["formData"])),

    createAccountToCardTransferRoutine: (payload) =>
      CoreAPIRequest.post(
        "/create_account_to_card_transfer_routine",
        payload,
        getAPIConfig(["astraToken", "formData"]),
      ),

    createAstraAccount: (payload) =>
      CoreAPIRequest.post("/create_astra_account", payload, getAPIConfig(["astraToken", "formData"])),

    checkRoutesCapabilities: () =>
      CoreAPIRequest.get(`/check_routes_capabilities/${getUserId()}`, getAPIConfig(["astraToken"])),
  },

  recurringDeposits: {
    getRecurringDeposit: () =>
      CoreAPIRequest.get(`mobile/residents/${getUserId()}/recurring_add_funds/`, getAPIConfig(["transferToken"])),
    activateRecurringDeposit: ({ userId, ...payload }) =>
      CoreAPIRequest.post(
        `mobile/residents/${userId}/recurring_add_funds/activate/`,
        payload,
        getAPIConfig(["transferToken"]),
      ),

    clearRecurringDeposit: ({ userId, ...payload }) =>
      CoreAPIRequest.patch(
        `mobile/residents/${userId}/recurring_add_funds/clear/`,
        payload,
        getAPIConfig(["transferToken"]),
      ),
  },

  termsOfService: {
    agreeToS: (payload) => CoreAPIRequest.post("/user/update_tos_agreement/", payload, getAPIConfig(["transferToken"])),
  },

  stakepay3: {
    getAuthToken: (sfid) => CoreAPIRequest.get(`/stake_pay/get_auth_token/${sfid}/`, getAPIConfig(["transferToken"])),
    getPaymentDetails: () =>
      CoreAPIRequest.get("/stake_pay/on_load_payment_details/", getAPIConfig(["stakePay3AuthToken"])),
    setupPayment: ({ isAutoPaySelected, ...payload }) =>
      CoreAPIRequest.post(
        `/stake_pay/${isAutoPaySelected ? "setup_auto_payment" : "setup_one_time_payment"}/`,
        { isAutoPaySelected, ...payload },
        getAPIConfig(["stakePay3AuthToken"]),
      ),
    getPaymentMonths: (sfid) =>
      CoreAPIRequest.get(`/stake_pay/get_payment_months/${sfid}/`, getAPIConfig(["stakePay3AuthToken"])),
    getPaymentSetupSummary: (sfid) =>
      CoreAPIRequest.get(`/stake_pay/get_payment_setup_summary/${sfid}/`, getAPIConfig(["stakePay3AuthToken"])),
    getAutopayPaymentSetupSummary: (sfid) =>
      CoreAPIRequest.get(`/stake_pay/get_autopay_payment_setup_summary/${sfid}/`, getAPIConfig(["stakePay3AuthToken"])),
    getPaymentDetailsForSelectedMonth: (contractPaymentId) =>
      CoreAPIRequest.get(
        `/stake_pay/get_payment_details_selected_month/${contractPaymentId}/`,
        getAPIConfig(["stakePay3AuthToken"]),
      ),
    cancelPayment: ({ isAutoPay, ...payload }) =>
      CoreAPIRequest.post(
        `/stake_pay/${isAutoPay ? "turn_off_autopay" : "cancel_onetime_payment"}/`,
        payload,
        getAPIConfig(["stakePay3AuthToken"]),
      ),
    editPayment: ({ isAutoPaySelected, ...payload }) =>
      CoreAPIRequest.post(
        `/stake_pay/${isAutoPaySelected ? "setup_auto_payment" : "save_single_payment_details"}/`,
        { isAutoPaySelected, ...payload },
        getAPIConfig(["stakePay3AuthToken"]),
      ),
    getPastPayments: (sfid) =>
      CoreAPIRequest.get(`/stake_pay/get_past_payments/${sfid}/`, getAPIConfig(["stakePay3AuthToken"])),
  },

  finix: {
    getCards: () => CoreAPIRequest.get(`/stake_pay/finix/cards/`, getAPIConfig(["stakePay3AuthToken"])),
    getFinixPublicKey: () => CoreAPIRequest.get("/stake_pay/finix/public_key/", getAPIConfig(["stakePay3AuthToken"])),
    createFinixSetupIntent: () =>
      CoreAPIRequest.post("/stake_pay/finix/create_intent/", {}, getAPIConfig(["stakePay3AuthToken"])),
    createFinixPaymentInstruments: (payload) =>
      CoreAPIRequest.post("/stake_pay/finix/payment_instruments/", payload, getAPIConfig(["stakePay3AuthToken"])),
    deleteCard: (cardId) =>
      CoreAPIRequest.delete(`/stake_pay/finix/card/${cardId}/`, getAPIConfig(["stakePay3AuthToken"])),
  },

  stripe: {
    getStripePublicKey: ({ useStakeStripe }) =>
      CoreAPIRequest.get(
        useStakeStripe ? "/api/stripe/publickey/" : "/stake_pay/stripe/public_key/",
        getAPIConfig(["stakePay3AuthToken"]),
      ),
    createStripeSetupIntent: ({ useStakeStripe }) =>
      CoreAPIRequest.post(
        useStakeStripe ? `/api/stripe/createintent/?sfid=${getUserSfid()}` : "/stake_pay/stripe/create_intent/",
        {},
        getAPIConfig(["stakePay3AuthToken"]),
      ),
  },

  knot: {
    createKnotSession: (card_id) => {
      const user = LocalStorage.read(appUtilityKeys.loggedInUserData);

      return CoreAPIRequest.post(
        "/v2/create_knot_session",
        convertObjectToFormData({
          user_id: user._id,
          email: user.email,
          phone_number: user.phoneNumber,
          card_id,
        }),
        getAPIConfig(["formData", "transferToken"]),
      );
    },
  },

  myUtilities: {
    createOrder: (payload) =>
      CoreAPIRequest.post("/api/my_utilities/create_order/", payload, getAPIConfig(["transferToken"])),
    getOrderDetail: (token) =>
      CoreAPIRequest.get(`/api/my_utilities/get_order/?token=${token}`, getAPIConfig(["transferToken"])),
  },

  stakeSaver: {
    joinStakeSaver: (payload) =>
      CoreAPIRequest.post(
        "/api/v4/join_stake_saver_bundle/?credit_builder=False",
        payload,
        getAPIConfig(["transferToken"]),
      ),
    cancelStakeSaver: () =>
      CoreAPIRequest.post(`/api/v2/cancel_stake_saver_bundle/`, {}, getAPIConfig(["transferToken"])),
    stakeSaverFormPrefill: () =>
      CoreAPIRequest.get(`/api/v2/stake_saver_form_prefill/`, getAPIConfig(["transferToken"])),
    setupStakeSaver: (payload) =>
      CoreAPIRequest.post("/api/v2/setup_stake_saver/", payload, getAPIConfig(["transferToken"])),
    applyStakeSaverDiscount: (payload) =>
      CoreAPIRequest.post("/api/v2/stake_saver/apply_discount/", payload, getAPIConfig(["transferToken"])),
  },

  consumerPaymentMethods: {
    getConsumerPaymentMethods: () =>
      CoreAPIRequest.get("/api/v2/consumer_payment_methods/", getAPIConfig(["transferToken"])),
    updateConsumerDealPaymentMethod: (payload) =>
      CoreAPIRequest.post("/api/v2/update_payment_method/", payload, getAPIConfig(["transferToken"])),
  },

  partnerSignUp: {
    isCustomerFromPartnerOnboarded: (payload) =>
      CoreAPIRequest.post(`/api/is_customer_from_partner_onboarded/`, payload),
    getPartnerCustomerInformation: (payload) => CoreAPIRequest.post("/api/partner_get_customer_information/", payload),
    onPartnerOnboardingLoad: (partnerId) => CoreAPIRequest.get(`/api/partner_onboarding_onload/${partnerId}`),
    savePartnerCustomerInformation: (payload) =>
      CoreAPIRequest.post("/api/save_customer_information_from_partner/", payload),
  },

  fidel: {
    getFidelPublicKey: () => CoreAPIRequest.get("/api/fidel/publickey/"),
    getLinkData: () => {
      const user = LocalStorage.read(appUtilityKeys.loggedInUserData);
      return CoreAPIRequest.post(`/api/fidel/get_link_data/?userId=${user._id}`);
    },
    getFidelCards: () => {
      const user = LocalStorage.read(appUtilityKeys.loggedInUserData);
      return CoreAPIRequest.get(`/api/fidel/get_fidel_cards/?userId=${user._id}`);
    },
    deleteFidelCard: (cardId) => CoreAPIRequest.delete(`/api/fidel/delete_card/?cardId=${cardId}`),
    getNearestLocations: ({ queryKey, pageParam }) => {
      const {resident_id, offerId,brandName,location,contentProviderId} = queryKey[1];
      const params = new URLSearchParams();
      if (offerId) params.append("offer_id", offerId);
      if (brandName) params.append("brand_name", brandName);
      if (location) params.append("location", location);
      if (contentProviderId) params.append("content_provider_id", contentProviderId);
      const offset = pageParam ?? 0;
      params.append("offset", offset);
      params.append("limit", 100);
      return CoreAPIRequest.get(
        `/api/fidel/nearest_locations/${resident_id}/?${params.toString()}`
      );
    },
  },
  
  directSignUp: {
    directSignupCustomer: (payload) => CoreAPIRequest.post("/api/direct_signup_customer/", payload),
    updateLeaseInformation: (payload, config) =>
      CoreAPIRequest.post("/api/update_lease_information/", payload, {
        ...getAPIConfig(["formData", "transferToken"]),
        ...config,
      }),
  },

  payee: {
    addPayee: (payload) => CoreAPIRequest.post("/api/add_payee/", payload, getAPIConfig(["transferToken"])),
    getPayees: () => CoreAPIRequest.get(`/api/payees/`, getAPIConfig(["transferToken"])),
    deletePayee: (payload) =>
      CoreAPIRequest.delete("/api/remove_payee/", { data: payload, headers: getAPIConfig(["transferToken"]).headers }),
    validateRoutingNumber: (routingNumber) =>
      CoreAPIRequest.get(`/api/routing_number/${routingNumber}/validate/`, getAPIConfig(["transferToken"])),
  },

  rentPayment: {
    initiateOneTimePayment: (payload) =>
      CoreAPIRequest.post("/api/initiate_counter_party_payment/", payload, getAPIConfig(["transferToken"])),
    getRentPayments: (params) =>
      CoreAPIRequest.get(`/api/counter_party_payments/`, {
        params,
        headers: getAPIConfig(["transferToken"]).headers,
      }),
    cancelOneTimePayment: (payload) =>
      CoreAPIRequest.delete("/api/cancel_payment/", {
        data: payload,
        headers: getAPIConfig(["transferToken"]).headers,
      }),
    getRecurringRentPayments: () => CoreAPIRequest.get(`/api/recurring_payment/get/`, getAPIConfig(["transferToken"])),
    createRecurringRentPayment: (payload) =>
      CoreAPIRequest.post("/api/recurring_payment/schedule/", payload, getAPIConfig(["transferToken"])),
    updateRecurringRentPayment: ({ recurringId, ...payload }) =>
      CoreAPIRequest.put(`/api/recurring_payment/${recurringId}/update/`, payload, getAPIConfig(["transferToken"])),
    cancelRecurringRentPayment: (recurringId) =>
      CoreAPIRequest.delete(`/api/recurring_payment/${recurringId}/cancel/`, getAPIConfig(["transferToken"])),
  },

  insurance: {
    getCustomerDetailsForInsurance: () =>
      CoreAPIRequest.get("/api/v1/get_customer_details_for_insurance/", getAPIConfig(["transferToken"])),
    saveInsuranceDetails: (payload) =>
      CoreAPIRequest.post(`/api/v1/save_insurance_details/`, payload, getAPIConfig(["transferToken"])),
    getInsurancePolicyDetails: () =>
      CoreAPIRequest.get("/api/v1/get_insurance_policy_details/", getAPIConfig(["transferToken"])),
  },

  // Soft signup capture for welcome AI flow (server endpoint to be implemented)
  softSignups: {
    createSoftSignup: (payload) => CoreAPIRequest.post("/api/soft_signups/", payload).catch((e) => e),
  },

  programs: {
    getPrograms: () => CoreAPIRequest.get("/api/programs", getAPIConfig(["transferToken"])),
    updateProgramPreviewStatus: () =>
      CoreAPIRequest.put("/api/programs/preview-status", {}, getAPIConfig(["transferToken"])),
  },

  appEssentials: { getAppEssentials: () => CoreAPIRequest.get("/api/app_essentials", getAPIConfig(["transferToken"])) },

  image: {
    getImage: (urls = []) =>
      Promise.all(
        urls.map((url) => {
          return fetch(url)
            .then((response) => response.blob())
            .then((blob) => URL.createObjectURL(blob));
        }),
      ),
  },
};
